import React, { useState, useEffect } from 'react';

export default function BeefBracketVoteTallyOtherContenders({
  view,
  otherContenders,
  scoreObject,
  setScoreObject
}) {
  return (
    <>
      <div
        className={`beef-bracket-vote-tally-score beef-bracket-vote-tally-score-contenders  ${view}`}
      >
        {otherContenders.map((contender, index) => (
          <div key={index} className="beef-bracket-vote-tally-score-card">
            <div
              className="beef-bracket-vote-tally-score-image"
              style={{ backgroundImage: `url(${contender.image})` }}
            >
              <img src={contender.image} alt={contender.title} />
            </div>
            <div className="beef-bracket-vote-tally-score-title">
              <h4>{contender.title}</h4>
            </div>
          </div>
        ))}
        <div className="beef-bracket-vote-tally-score-card u--display-none-xl-min">
          <div
            className="beef-bracket-vote-tally-score-image"
            style={{ backgroundImage: `url(${scoreObject.image})` }}
          >
            <img src={scoreObject.image} alt={scoreObject.title} />
          </div>
          <div className="beef-bracket-vote-tally-score-title">
            <h4>{scoreObject.title}</h4>
          </div>
        </div>
      </div>
      <div
        className={`beef-bracket-vote-tally-score beef-bracket-vote-tally-score-contenders u--display-none-lg-max  ${view}`}
      >
        <div className="beef-bracket-vote-tally-score-card">
          <div
            className="beef-bracket-vote-tally-score-image"
            style={{ backgroundImage: `url(${scoreObject.image})` }}
          >
            <img src={scoreObject.image} alt={scoreObject.title} />
          </div>
          <div className="beef-bracket-vote-tally-score-title">
            <h4>{scoreObject.title}</h4>
          </div>
        </div>
      </div>
    </>
  );
}
